import { Component, OnInit } from '@angular/core';
import { LocationStrategy } from '@angular/common';

import * as _ from 'lodash';
import { ModuleKeyDefinition } from '../../constants/module.constant';
import { TeamnoteConfigService } from '../../configs/teamnote-config.service';
import { LocalStorageManagerService } from '../local-storage/local-storage-manager.service';
import { TeamNoteLocalStorageKeyConstants } from '../../constants/local-storage-key.constant';
import { RouteParamService } from '../route-param/route-param.service';
import { BaseRoutingService } from '../../routing/base-routing.service';
import { SideNavItem, SideNavService } from './side-nav.service';
import { TranslateManagerService } from '../../utilities/translate/translate-manager.service';
import { PageUrlConstant } from '../../constants/page-url.constant';
import { ActivatedRoute, Router, UrlTree } from '@angular/router';
import { VideoCallService } from '../../../app/webclient/chat/chat-room/video-call/video-call.service';
import { TnNotificationService } from '../tn-notification/tn-notification.service';

@Component({
  selector: 'tn-side-nav',
  templateUrl: './tn-side-nav.component.html',
  styleUrls: ['./tn-side-nav.component.scss']
})

export class TnSideNavComponent implements OnInit {
  sideNavItems: SideNavItem[];

  MODULE_KEYS = ModuleKeyDefinition;

  currentNavItemKey: string = null;

  constructor(
    private _teamnoteConfigService: TeamnoteConfigService,
    private _localStorageManagerService: LocalStorageManagerService,
    private _routeParamService: RouteParamService,
    private _baseRoutingService: BaseRoutingService,
    private _sideNavService: SideNavService,
    private _translateManagerService: TranslateManagerService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _locationStrategy: LocationStrategy,
    private _videoCallService: VideoCallService,
    private _tnNotificationService: TnNotificationService,
  ) { 
    this.sideNavItems = [];

    this._sideNavService.sideNavItems$.subscribe(sideNavs => {
      this.sideNavItems = sideNavs;
      this.currentNavItemKey = this._sideNavService.currentActiveItemKey;

      this.updateSideNavModuleName();
    });

    // translate the side nav module name after switching language
    this._translateManagerService.currentTranslation$.subscribe(lang => {
      this.updateSideNavModuleName();
    });
  }

  ngOnInit() {
    this.restorePrevSideNav();
  }

  isCheckPlaceholder(module_name: string) {
    return module_name.charAt(0) === ' '
  }

  updateSideNavModuleName(): void {
    _.forEach(this.sideNavItems, (module) => {
      if (module._i18n) {
        let i18n = module._i18n[this._translateManagerService.getCurrentLangI18nKey()];
        
        if (i18n && i18n.side_menu_name !== '') {
          module.name = i18n.side_menu_name;
        }
      }
    })
  }

  restorePrevSideNav(): void {
    let prev = this._localStorageManagerService.getCookiesByKey(TeamNoteLocalStorageKeyConstants.USER_CONFIG_COOKIES.ROUTE_MODULE);
    this.currentNavItemKey = prev ? prev : this._teamnoteConfigService.config.WEBCLIENT.GENERAL.WEBCLIENT_DEFAULT_PAGE;

    this._sideNavService.updateActiveSideNav(this.currentNavItemKey);
  }

  // Same target as [routerLink]="item.link" from this component's position (relative to the webclient route)
  getNavItemUrlTree(navItem: SideNavItem): UrlTree {
    return navItem.link != null ? this._router.createUrlTree([navItem.link], { relativeTo: this._route }) : null;
  }

  // Real href so ctrl/cmd/shift/middle click and "open in new tab" are handled natively by the browser
  getNavItemHref(navItem: SideNavItem): string {
    let urlTree = this.getNavItemUrlTree(navItem);
    return urlTree ? this._locationStrategy.prepareExternalUrl(this._router.serializeUrl(urlTree)) : null;
  }

  changeRoute(navItem: SideNavItem, event: MouseEvent): void {
    // Like RouterLink: modifier clicks are left to the browser (new tab/window); only plain left clicks route in-app
    let isPlainLeftClick = event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey;

    if (isPlainLeftClick) {
      event.preventDefault();

      if (this._videoCallService.isVideoCalling) {
        this.showEndCallBeforeLeavingWarning();
        return
      }
    }

    this.currentNavItemKey = navItem.key;

    this._sideNavService.updateActiveSideNav(navItem.key);
    
    this._routeParamService.setRouteParam(navItem.params);

    let urlTree = this.getNavItemUrlTree(navItem);
    if (isPlainLeftClick && urlTree) {
      this._router.navigateByUrl(urlTree);
    }
  }

  changeTeamflarePageRoute(navItem: SideNavItem): void {
    if (this._videoCallService.isVideoCalling) {
      this.showEndCallBeforeLeavingWarning();
      return
    }

    this.currentNavItemKey = navItem.key;

    this._sideNavService.updateActiveSideNav(navItem.key);
    
    this._routeParamService.setRouteParam(navItem.params);

    if (!navItem.url) {
      alert('TeamFlare URL is invalid')
      return
    }

    // route to path [API_HOST]/#/webclient/teamflare_app/https://xxx.com
    this._router.navigate(['../' + PageUrlConstant.WEBCLIENT.BASE + navItem.link.slice(1), navItem.url]);
  }

  showEndCallBeforeLeavingWarning(): void {
    this._tnNotificationService.showCustomWarningByTranslateKey('WEBCLIENT.CHATROOM.VIDEO_CALL.END_CALL_BEFORE_LEAVING');
  }
}
